import ModalContentWrapper from "root/s360components/Modals/ModalContentWrapper";
import './ModalEnableSchoolGDPR.scss';
import {modifyGDPRAccessForSchool} from "root/DataFunctions/SchoolDataFns";
import {useState} from "react";

const ModalEnableSchoolGDPR = ({onClose, school_id, school_name, GDPR_current_state}) =>
{

    const [disabled, setDisabled] = useState(false);

    const onSubmit = (school_id, old_flag) =>
    {

        setDisabled(true);
        //Reversing the flag so that it changes when submitted
        const new_flag = +old_flag === 0 ? 1 : 0;

        modifyGDPRAccessForSchool(school_id, new_flag, (resp) =>
        {
            onClose(true);
            setDisabled(false);
        })
    }

    const verb = +GDPR_current_state === 0 ? "ENABLE" : "DISABLE";
    const verb_color = +GDPR_current_state === 0 ? "green" : "red";

    return (
        <ModalContentWrapper  className="modal-wrapper">
            <div className="modal-enable-school-gdpr">
                <h2>Enable GDPR</h2>
                <p>Are you sure you want to <i style={{color: verb_color}}>{verb}</i> GDPR for <i className="highlight-text">{school_name}</i> ?</p>
                <div className='GDPR-buttons'>
                    <button className="btn btn-secondary btn-space-right" onClick={() => onClose()}>Cancel</button>
                    <button className="btn btn-primary btn-space-right" disabled = {disabled} onClick={() => onSubmit(school_id, GDPR_current_state)}>Submit
                    </button>
                </div>
            </div>
        </ModalContentWrapper>
    )
}

export default ModalEnableSchoolGDPR;